<template>
  <div class="box wrapper-salary-receipt-employee">
    <h2 class="title is-4 has-text-primary title-salary-receipt-employee">
      Datos del Empleado
    </h2>
    <div class="columns is-multiline">
      <div class="column is-12">
        <BField
          label-for="name-search"
          label="Buscar/crear empleado por nombre"
        >
          <BAutocomplete
            id="name-search"
            :value="text"
            field="name"
            placeholder="Nombre del empleado"
            :data="basicEmployees"
            :loading="isFetching"
            open-on-focus
            @keyup.native="getEmployeesByName"
            @select="onSelect"
            @input="onInput"
          >
            <template slot="header">
              <RouterLink
                class="button is-text"
                :to="{ name: 'PushBasicEmployee' }"
              >
                <span>Crear empleado</span>
              </RouterLink>
            </template>
            <template slot="empty">
              No se encontraron empleados con este nombre
            </template>
            <template slot-scope="props">
              <div class="media">
                <div class="media-content">
                  Nombre: {{ props.option.name }} <br>
                  <small>
                    CURP: {{ props.option.curp }}
                  </small>
                </div>
              </div>
            </template>
          </BAutocomplete>
        </BField>
      </div>
      <div class="column is-12">
        <BField label="Email">
          <BInput
            v-model="email"
            disabled
          />
        </BField>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import debounce from 'lodash/debounce';

import api from '../../../lib/api';

export default {
  name: 'PayrollBasicReceiver',
  data() {
    return {
      isFetching: false,
      name: '',
      basicEmployees: [],
      selected: null,
    };
  },
  computed: {
    ...mapState({
      email: state => state.employee.email,
    }),
    canceled() {
      return [201, 202].includes(this.status);
    },
    text() {
      return this.$store.state.employee.name;
    },
  },
  methods: {
    getEmployeesByName: debounce(async function getEmployeesByCompany() {
      if (this.text.length < 3) return;

      this.isFetching = true;

      const { rows } = await api.employees.getAllBasicByCompany(
        this.$store.state.auth.companyId,
        { name: this.text },
      );

      this.basicEmployees = rows;

      this.isFetching = false;
    }, 800),
    onSelect(option) {
      this.selected = option;
      const {
        id,
        name,
        email,
        curp,
        concept,
        amount,
      } = option;

      this.name = name;
      this.email = email;
      this.$store.commit('employee/setValues', {
        id,
        name,
        email,
        curp,
        concept,
        amount,
      });
      this.$store.commit('payroll/setPercepts', { concept, amount });
    },
    onInput(value) {
      this.$store.commit('employee/setValue', { accessor: 'name', value });
    },
  },
};
</script>

<style scoped>
.title {
  margin-bottom: 1rem;
}
</style>
